/* Extracted from the inline <script> in sections/collection-left-nav.liquid (2 of 3: vehicle picker + collection.php) so browsers can cache it; loaded with defer. Page values arrive via window.pcCollectionCfg, set inline by the section. */
(function(){
  const DATA_URL = 'https://shopify.partcatalog.com/vehicles_index.json';

  const el = document.getElementById('ymm');
  const fitbar = document.getElementById('pc-fitbar');
  if(!el) return;

  const selYear  = document.getElementById('pc-col-year');
  const selMake  = document.getElementById('pc-col-make');
  const selModel = document.getElementById('pc-col-model');
  const findBtn  = document.getElementById('pc-col-find');

  const headingEl  = el.querySelector('.ymm__heading');
  const selectedEl = el.querySelector('.ymm__selected');
  const fitbarNameEl   = fitbar ? fitbar.querySelector('[data-fitbar-name]') : null;
  const fitbarChangeBtn = fitbar ? fitbar.querySelector('[data-fitbar-change]') : null;
  const fitbarClearBtn  = fitbar ? fitbar.querySelector('[data-fitbar-clear]') : null;

  // Qualifier-asking UI mount points - the selects/chips render
  // inside the picker itself now, not the old standalone ".pc-refine-bar".
  const pickerQualsEl      = document.getElementById('pc-picker-quals');
  const pickerQualsLabelEl = document.getElementById('pc-picker-quals-label');
  const fitbarQualsEl      = fitbar ? document.getElementById('pc-fitbar-quals') : null;

  const STORAGE_KEY = 'pc_ymm_v1';
  // Flat, top-level qualifier keys the PDP/collection stash on the same stored
  // object (other scripts read/write these too) - a changed Y/M/M invalidates them.
  const QUAL_KEYS = ['Submodel','SubModel','BodyType','BedType','BodyNumDoors','BedLength','DriveType','EngineBase','TransmissionControlType','EngineVIN','FuelType','WheelBase'];

  let vData = null;

  // --- storage helpers ---
  // MERGE-SAVE: preserve any unknown extra keys already in storage (e.g. the
  // PDP's sku/qualifier fields) instead of clobbering the whole object. Only
  // wipe the qualifier keys + sku when the vehicle itself actually changed -
  // a same-vehicle re-save keeps everything.
  function saveVehicle(sel){
    let existing = null;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) existing = JSON.parse(raw);
    } catch {}
    if (!existing || typeof existing !== 'object') existing = {};

    const year = String(sel.year);
    const changed = String(existing.year) !== year || existing.make !== sel.make || existing.model !== sel.model;

    const merged = Object.assign({}, existing, { year: year, make: sel.make, model: sel.model });
    if (changed) {
      QUAL_KEYS.forEach(k => delete merged[k]);
      delete merged.sku;
    }

    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(merged)); } catch {}
    document.cookie = 'pc_ymm=' + encodeURIComponent(JSON.stringify(merged)) + '; Max-Age=' + (60*60*24*30) + '; Path=/; SameSite=Lax';
    document.dispatchEvent(new CustomEvent('vehicle:changed',{ detail: merged }));
  }

  function readVehicle(){
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch {}
    const m = document.cookie.match(/(?:^|;)\s*pc_ymm=([^;]+)/);
    if (m) { try { return JSON.parse(decodeURIComponent(m[1])); } catch {} }
    return null;
  }

  function clearVehicle(){
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
    document.cookie = 'pc_ymm=; Max-Age=0; Path=/; SameSite=Lax';
    document.dispatchEvent(new CustomEvent('vehicle:cleared'));
    headingEl.hidden = false;
    headingEl.textContent = 'Select your vehicle';
    if (fitbar) fitbar.hidden = true;
    // Reset the qualifier-picker UI along with everything else
    // clearVehicle() already wipes.
    if (pickerQualsEl) pickerQualsEl.innerHTML = '';
    if (pickerQualsLabelEl) { pickerQualsLabelEl.hidden = true; pickerQualsLabelEl.textContent = ''; pickerQualsLabelEl.classList.remove('pc-picker__quals-label--attention'); }
    if (fitbarQualsEl) { fitbarQualsEl.hidden = true; fitbarQualsEl.innerHTML = ''; }
    // Vehicle mode is over - clear the Sort script's signal (see
    // renderVehicleRefinements above) so it goes back to full-navigation sort.
    if (fitbar) fitbar.removeAttribute('data-vehicle-active');
    if (window.pcRestoreSSRCollectionChrome) window.pcRestoreSSRCollectionChrome();
  }

  // --- saved-mode UI: query the API, then let renderVehicleRefinements()
  // (called from sendVehicleToAPI's response handler) decide whether to
  // collapse the picker into the fitbar (fully qualified) or keep the picker
  // open with qualifier asks. For an interactive pick
  // (findBtn / URL vehicle / answering or removing a qualifier) we don't
  // collapse optimistically - we don't yet know which state applies, and
  // collapsing then immediately reopening for an under-qualified result
  // would be a worse flash than just waiting.
  // `opts.isBoot` marks a boot-restore (landing with a previously saved
  // vehicle) - Fix round 1 (Q1): this is the common returning-visitor case,
  // usually fully qualified, so it collapses to the fitbar optimistically
  // here (same as before) to avoid flashing the open picker on every
  // load. If the response comes back under-qualified, renderVehicleRefinements()
  // reopens the picker; if the request errors, nothing reverts this collapse,
  // so the fitbar simply stays put instead of leaving the picker open/stuck.
  // Fix round 2: the amber "confirm your vehicle" attention treatment is no
  // longer tied to isBoot - renderVehicleRefinements() applies it to EVERY
  // under-qualified render (fresh pick, boot-restore, URL deep-link, or a
  // refinement pick that's still short of fully qualified), since the whole
  // point is to make an unanswered qualifier select impossible to miss no
  // matter how the picker got there.
  function showSaved(sel, opts){
    if (fitbarNameEl) fitbarNameEl.textContent = fitbarNameParts(sel).join(' ');
    if (opts && opts.isBoot) {
      el.hidden = true;
      if (fitbar) fitbar.hidden = false;
    }
    sendVehicleToAPI(sel, opts);
  }

  // Fitbar label = "Year Make Model" + applied qualifier VALUES appended after
  // the model - SubModel/Submodel first, then the rest in QUAL_KEYS order.
  // Case-tolerant against however the qualifier key is actually cased in
  // storage (PDP vs. API-applied casing can differ; see QUAL_KEYS above).
  function fitbarNameParts(sel) {
    const parts = [sel.year, sel.make, sel.model];
    const subFirst = QUAL_KEYS.filter(k => k.toLowerCase() === 'submodel');
    const rest = QUAL_KEYS.filter(k => k.toLowerCase() !== 'submodel');
    const seenLower = new Set();
    for (const qk of subFirst.concat(rest)) {
      const lowerK = qk.toLowerCase();
      if (seenLower.has(lowerK)) continue;
      seenLower.add(lowerK);
      const matchKey = Object.keys(sel).find(sk => sk.toLowerCase() === lowerK);
      if (matchKey == null) continue;
      const v = sel[matchKey];
      if (v != null && String(v).trim() !== '') parts.push(String(v).trim());
    }
    return parts;
  }

  // Build the qualifiers payload from the stored vehicle's extra keys, matched
  // against QUAL_KEYS case-tolerantly (the PDP and API-applied refinements can
  // disagree on casing, e.g. "Submodel" vs "SubModel") - sent under whatever
  // casing is actually in storage, since that's what the qualifier came from.
  function buildQualifiers(sel) {
    const qualifiers = {};
    if (!sel) return qualifiers;
    const validLower = QUAL_KEYS.map(k => k.toLowerCase());
    for (const sk of Object.keys(sel)) {
      if (!validLower.includes(sk.toLowerCase())) continue;
      const v = sel[sk];
      if (v != null && String(v).trim() !== '') qualifiers[sk] = String(v).trim();
    }
    return qualifiers;
  }

  // Field label for a refinement/qualifier key - reuses FITMENT_LABELS (the
  // sidebar filter rail's label map) where it has the key, same special-case
  // for EngineBase as the original, falling back to a camelCase split.
  function refinementLabel(name) {
    if (name === 'EngineBase') return 'Engine';
    try { if (typeof FITMENT_LABELS === 'object' && FITMENT_LABELS[name]) return FITMENT_LABELS[name]; } catch {}
    return String(name).replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  // Markup for one removable "answered qualifier" chip - shared by both
  // mount points (inside the picker while under-qualified, next to the
  // fitbar name once collapsed).
  function qualChipHtml(name, value) {
    const label = esc(refinementLabel(name));
    return '<span class="pc-qual-chip">'
      + '<span class="pc-qual-chip__label">' + label + ': ' + esc(value) + '</span>'
      + '<button type="button" class="pc-qual-chip__x" data-qual-remove="' + esc(name) + '" aria-label="Remove ' + label + '">&times;</button>'
      + '</span>';
  }

  // Markup for one unanswered-refinement select - same select
  // vocabulary as the Y/M/M pickers (.pc-picker__sel), plus the amber
  // attention modifier. Fix round 2: attention is always on for an
  // unanswered qualifier select, regardless of how the picker got here.
  function qualSelectHtml(f, attention) {
    const fname = (f && f.name) || '';
    const flabel = esc((f && f.label) || refinementLabel(fname));
    let opts = '<option value="">' + flabel + '</option>';
    const optList = (f && Array.isArray(f.options)) ? f.options : [];
    for (const opt of optList) opts += '<option value="' + esc(opt) + '">' + esc(opt) + '</option>';
    const cls = 'pc-picker__sel' + (attention ? ' pc-picker__sel--attention' : '');
    return '<select class="' + cls + '" data-qual-select="' + esc(fname) + '" aria-label="' + flabel + '">' + opts + '</select>';
  }

  function wireQualChips(container) {
    container.querySelectorAll('[data-qual-remove]').forEach(btn => {
      btn.addEventListener('click', () => removeVehicleQualifier(btn.getAttribute('data-qual-remove')));
    });
  }

  function wireQualSelects(container) {
    container.querySelectorAll('[data-qual-select]').forEach(selEl => {
      selEl.addEventListener('change', () => {
        if (selEl.value) applyVehicleRefinement(selEl.getAttribute('data-qual-select'), selEl.value);
      });
    });
  }

  // "CONFIRM YOUR VEHICLE - SELECT <...> TO NARROW RESULTS" - adapts the
  // trailing words to the actual unanswered refinement labels when there
  // are a handful of them; falls back to the generic copy otherwise.
  function buildAttentionLabel(asks) {
    const labels = asks.map(f => (f && (f.label || refinementLabel(f.name))) || '').filter(Boolean);
    const words = (labels.length && labels.length <= 3) ? labels.join('/').toUpperCase() : 'TRIM/ENGINE';
    return 'CONFIRM YOUR VEHICLE — SELECT ' + words + ' TO NARROW RESULTS';
  }

  /* ---------- Vehicle qualifier UI ----------
     Renders into the picker area (unanswered refinements + removable chips
     for already-applied ones, appended after the Model select) while the
     vehicle is under-qualified, or into the fitbar (chips only) once every
     suggested refinement has been answered and the picker collapses. This
     replaces the old standalone ".pc-refine-bar" between the fitbar and the
     toolbar - that markup/CSS/render-path is gone; this function now owns
     both picker-open and fitbar-collapsed rendering.

     Fix round 2: the amber attention border + bold "CONFIRM YOUR VEHICLE"
     label render for EVERY under-qualified state this function renders -
     fresh in-session pick, boot-restore of a saved under-qualified vehicle,
     a URL deep-link, or an in-picker refinement pick that's still short -
     not just a boot-restore landing. `opts` is kept for future use but no
     longer gates attention; see the `isFullyQualified` branch below, where
     attention is simply "one or more qualifier selects are being rendered
     unanswered right now." Answered/collapsed (fully-qualified) state is
     unaffected, and Y/M/M selects never get the amber border - only the
     unanswered qualifier selects rendered in the under-qualified branch. */
  function renderVehicleRefinements(refinements, appliedQualifiers, opts) {
    // Vehicle-API rows are showing regardless of which branch below picks -
    // mark the fitbar as "vehicle mode active" via a dedicated attribute
    // (independent of its `hidden` state, which is now also used to mean
    // "picker is collapsed", not just "a vehicle is selected"). The Sort
    // script below observes this to keep its client-side vs.
    // full-navigation sort decision correct in the under-qualified state.
    if (fitbar) fitbar.setAttribute('data-vehicle-active', '1');

    const applied = (appliedQualifiers && typeof appliedQualifiers === 'object')
      ? Object.entries(appliedQualifiers).filter(([, v]) => v != null && String(v).trim() !== '')
      : [];
    // Fix round 1 (Q2): a refinement whose name is already answered - but
    // under different casing than the API happens to label the refinement
    // with (e.g. the PDP stores "Submodel", the API's own refinements[].name
    // is "SubModel") - must not render as an unanswered ask select (chip +
    // select for the same key, and collapse permanently blocked). Match
    // case-insensitively, same normalization spirit as deleteQualifierKeyCI.
    // Display/collapse-decision only - does NOT touch what buildQualifiers
    // sends or what applyVehicleRefinement stores (still the API's f.name,
    // as-is).
    const appliedNamesLower = new Set(applied.map(([name]) => String(name).toLowerCase()));
    const asks = (Array.isArray(refinements) ? refinements : [])
      .filter(f => !appliedNamesLower.has(String((f && f.name) || '').toLowerCase()));
    const isFullyQualified = asks.length === 0;

    // Always rebuild both mount points fresh - whichever one isn't relevant
    // for this render is simply left empty/hidden.
    if (pickerQualsEl) pickerQualsEl.innerHTML = '';
    if (pickerQualsLabelEl) {
      pickerQualsLabelEl.hidden = true;
      pickerQualsLabelEl.textContent = '';
      pickerQualsLabelEl.classList.remove('pc-picker__quals-label--attention');
    }
    if (fitbarQualsEl) { fitbarQualsEl.hidden = true; fitbarQualsEl.innerHTML = ''; }

    if (isFullyQualified) {
      // Collapse to the fitbar; any applied qualifiers surface as removable
      // chips next to the fitbar's vehicle name.
      el.hidden = true;
      if (fitbar) fitbar.hidden = false;
      if (applied.length && fitbarQualsEl) {
        fitbarQualsEl.hidden = false;
        fitbarQualsEl.innerHTML = applied.map(([name, value]) => qualChipHtml(name, value)).join('');
        wireQualChips(fitbarQualsEl);
      }
      return;
    }

    // Under-qualified: keep the picker open/prominent, hide the fitbar, and
    // always apply the amber attention treatment - reaching this branch at
    // all means one or more qualifier selects are about to render unanswered,
    // regardless of how we got here (fresh pick, boot-restore, URL deep-link,
    // or an in-picker refinement pick that's still short).
    el.hidden = false;
    if (fitbar) fitbar.hidden = true;

    if (pickerQualsLabelEl) {
      pickerQualsLabelEl.hidden = false;
      pickerQualsLabelEl.classList.add('pc-picker__quals-label--attention');
      pickerQualsLabelEl.textContent = buildAttentionLabel(asks);
    }

    if (pickerQualsEl) {
      let html = '';
      for (const [name, value] of applied) html += qualChipHtml(name, value);
      for (const f of asks) html += qualSelectHtml(f, true);
      pickerQualsEl.innerHTML = html;
      wireQualChips(pickerQualsEl);
      wireQualSelects(pickerQualsEl);
    }
  }

  // Storage write shared by applyVehicleRefinement/removeVehicleQualifier -
  // same STORAGE_KEY/cookie path as saveVehicle, but no "vehicle changed"
  // event dispatch here (Y/M/M didn't change) and no QUAL_KEYS purge.
  function persistRefinedVehicle(sel) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(sel)); } catch {}
    document.cookie = 'pc_ymm=' + encodeURIComponent(JSON.stringify(sel)) + '; Max-Age=' + (60*60*24*30) + '; Path=/; SameSite=Lax';
  }

  // Delete every key on `sel` that case-insensitively matches `name` - shared
  // by apply (dedupe before write, so a qualifier never ends up stored under
  // two casing variants at once, e.g. "Submodel" + "SubModel") and remove
  // (so whichever casing is stored actually goes, regardless of which
  // casing the chip/select happened to be labeled with).
  function deleteQualifierKeyCI(sel, name) {
    const target = String(name).toLowerCase();
    for (const k of Object.keys(sel)) {
      if (k.toLowerCase() === target) delete sel[k];
    }
  }

  function applyVehicleRefinement(name, value) {
    const sel = readVehicle();
    if (!sel || !sel.year || !sel.make || !sel.model) return;
    deleteQualifierKeyCI(sel, name); // dedupe: drop any other-cased key first
    sel[name] = value;
    persistRefinedVehicle(sel);
    document.dispatchEvent(new CustomEvent('vehicle:refined', { detail: sel }));
    showSaved(sel); // re-queries via the existing showSaved -> sendVehicleToAPI path
  }

  function removeVehicleQualifier(name) {
    const sel = readVehicle();
    if (!sel || !sel.year || !sel.make || !sel.model) return;
    deleteQualifierKeyCI(sel, name); // "Submodel" (PDP) and "SubModel" (API) both go
    persistRefinedVehicle(sel);
    document.dispatchEvent(new CustomEvent('vehicle:refined', { detail: sel }));
    showSaved(sel); // re-queries via the existing showSaved -> sendVehicleToAPI path
  }

  // === External API call ===

async function sendVehicleToAPI(sel, opts) {
  // Guard: ensure vehicle and collection data exist
  if (!sel || !sel.year || !sel.make || !sel.model) return;

  const debugEl = document.getElementById('api-debug');

  // Shopify makes the current collection available in Liquid
  const collectionId = (window.pcCollectionCfg || {}).collectionId || null;
  if (!collectionId) return;

  const payload = {
    collection_id: collectionId,
    year: sel.year,
    make: sel.make,
    model: sel.model
  };
  // Brand pages narrow by part type through the tag URL
  // (/collections/<brand>/<part-type>); the endpoint filters on it.
  const cfgPartType = (window.pcCollectionCfg || {}).partType;
  if (cfgPartType) payload.part_type = cfgPartType;

  // Extra qualifiers saved with the vehicle (PDP fitment checker, or a prior
  // refinement pick) narrow the results further. The API treats blank
  // fitment-row values as wildcards, so sending these only ever narrows.
  const qualifiers = buildQualifiers(sel);
  if (Object.keys(qualifiers).length) payload.qualifiers = qualifiers;

  try {
    if (debugEl) {
      debugEl.style.display = 'block';
      debugEl.textContent = '⏳ Sending request...\n' + JSON.stringify(payload, null, 2);
    }

    const res = await fetch('https://shopify.partcatalog.com/collection.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!res.ok) throw new Error('HTTP ' + res.status);

    const data = await res.json();

    // === Optional: pretty-print response ===
    if (debugEl) {
      debugEl.textContent = 'API Response:\n' + JSON.stringify(data, null, 2);
    }

    // Render the table from API results
	renderCatalogLinesFromAPI(data);

	if (Array.isArray(data.CatalogLines)) {
	  renderFilterPills(data.CatalogLines);
	  // "In Stock Only" defaults ON - re-render through the filter path so the
	  // initial view honors it (facet filters are empty at this point).
	  if (inStockOnly) applyFitmentFilters(data.CatalogLines, activeFilters);
	}

	// Vehicle refinements: refinements still open + qualifiers already
	// applied, straight from the (now narrower) response. Also decides
	// picker-vs-fitbar collapse. Fix round 2: the amber
	// attention treatment is no longer gated on opts.isBoot - it applies
	// to every under-qualified render inside renderVehicleRefinements()
	// itself, so `opts` doesn't need to be threaded through for that.
	renderVehicleRefinements(data.refinements, data.qualifiers, opts);

    // === Optional: handle returned JSON (e.g. filter collection) ===
    // updateUIWithFitment(data);

  } catch (err) {
    //console.error('Vehicle API request failed:', err);
    if (debugEl) {
      debugEl.style.display = 'block';
      debugEl.textContent = 'Error:\n' + err.message;
    }
  }
}



  function exitSaved(){
    el.hidden = false;
    selectedEl.hidden = true;
    if (fitbar) fitbar.hidden = true;
  }

  /* ---- Dropdown helpers (ported from pc-homepage.liquid's Y/M/M cascade) ---- */
  function fill(sel, options, placeholder) {
    sel.innerHTML = '<option value="">' + placeholder + '</option>';
    options.forEach(o => {
      const opt = document.createElement('option');
      opt.value = o; opt.textContent = o;
      sel.appendChild(opt);
    });
  }
  function makesForYear(data, year) {
    return Object.keys(data.byYear[year] || {}).sort((a,b) => a.localeCompare(b));
  }
  function modelsForYearMake(data, year, make) {
    return ((data.byYear[year] || {})[make] || []).slice().sort((a,b) => a.localeCompare(b));
  }

  function resetPicker(){
    fill(selYear, vData ? Object.keys(vData.byYear).sort((a,b)=>b-a) : [], 'Select Year');
    selYear.value = '';
    fill(selMake, [], 'Select Make');
    selMake.disabled = true;
    fill(selModel, [], 'Select Model');
    selModel.disabled = true;
    findBtn.disabled = true;
  }

  function prefillPicker(sel){
    if (!vData || !sel) return;
    const year = String(sel.year);
    fill(selYear, Object.keys(vData.byYear).sort((a,b)=>b-a), 'Select Year');
    selYear.value = year;
    fill(selMake, makesForYear(vData, year), 'Select Make');
    selMake.disabled = false;
    selMake.value = sel.make;
    fill(selModel, modelsForYearMake(vData, year, sel.make), 'Select Model');
    selModel.disabled = false;
    selModel.value = sel.model;
    findBtn.disabled = !selModel.value;
  }

  /* ---- Cascading selects: disable -> refill -> enable, same sequencing as the homepage ---- */
  selYear.addEventListener('change', () => {
    selMake.disabled = true; selModel.disabled = true; findBtn.disabled = true;
    fill(selMake, [], 'Select Make');
    fill(selModel, [], 'Select Model');
    if (!selYear.value || !vData) return;
    fill(selMake, makesForYear(vData, selYear.value), 'Select Make');
    selMake.disabled = false;
  });

  selMake.addEventListener('change', () => {
    selModel.disabled = true; findBtn.disabled = true;
    fill(selModel, [], 'Select Model');
    if (!selYear.value || !selMake.value || !vData) return;
    fill(selModel, modelsForYearMake(vData, selYear.value, selMake.value), 'Select Model');
    selModel.disabled = false;
  });

  selModel.addEventListener('change', () => {
    findBtn.disabled = !selModel.value;
  });

  findBtn.addEventListener('click', () => {
    const year = selYear.value, make = selMake.value, model = selModel.value;
    if (!year || !make || !model) return;
    const sel = { year, make, model };
    saveVehicle(sel);
    showSaved(sel); // posts to the API internally
  });

  // --- initial load of JSON + optionally hydrate from saved selection ---
  fetch(DATA_URL, { credentials: 'omit', cache: 'no-cache' })
    .then(r => { if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
    .then(json => {
	  vData = json;
	  fill(selYear, Object.keys(vData.byYear).sort((a,b)=>b-a), 'Select Year');

	  // 1) Check URL first and override session if valid
	  const urlSelRaw = readVehicleFromURL();
	  // Audit TH-2: a URL vehicle is honoured only when it matches the vehicle
	  // index. The old "|| urlSelRaw" fallback saved any ?Year=&Make=&Model= a
	  // link carried for 30 days and sent it to every backend as the shopper's
	  // own choice. An unknown vehicle in the URL is simply ignored.
	  let urlSel = validateVehicleAgainstData(urlSelRaw, vData);

	  if (urlSel && urlSel.year && urlSel.make && urlSel.model) {
		// This OVERRIDES any saved vehicle
		saveVehicle(urlSel);
		// normalize URL (canonical casing) without creating an extra history entry
		updateURLForVehicle(urlSel, { replace: true });

		// Reflect in UI and call your API immediately (showSaved() posts internally)
		prefillPicker(urlSel);
		showSaved(urlSel);
		return; // short-circuit: we’re done
	  }

	  // 2) Fall back to saved selection - a boot-restore.
	  // `isBoot` still controls the optimistic fitbar collapse in showSaved()
	  // above; an under-qualified result renders in the same amber "confirm
	  // your vehicle" attention state as every other under-qualified path
	  // (Fix round 2 - see renderVehicleRefinements()).
	  const saved = readVehicle();
	  if (saved && saved.year && saved.make && saved.model) {
		prefillPicker(saved);
		showSaved(saved, { isBoot: true });
		return;
	  }

	  // 3) No URL, no saved - leave the fresh, empty picker as-is
	})

    .catch(err => {
      //console.error('YMM load failed:', err);
      const years = [];
      for (let y = new Date().getFullYear() + 1; y >= 1980; y--) years.push(String(y));
      fill(selYear, years, 'Select Year');
    });

  // === Clear / Change vehicle ===
  if (fitbarClearBtn) fitbarClearBtn.addEventListener('click', () => {
    clearVehicle();
    exitSaved();
    resetPicker();
  });

  // "Change vehicle" reopens the picker without clearing the saved selection -
  // a new Find click (or Clear) is what actually overwrites/removes it.
  if (fitbarChangeBtn) fitbarChangeBtn.addEventListener('click', () => {
    exitSaved();
    prefillPicker(readVehicle());
  });
})();
